import React, { Component } from 'react'
import styled from 'styled-components'
import { Checkbox } from 'react-mdl'
import { injectState } from 'freactal'
import { hasElement } from '../../lib'
import set from 'lodash.set'
import isEqual from 'lodash.isequal'

const Container = styled.div`
  .mdl-data-table {
    width: 100%;
  }
`
const Table = styled.table`
  width: 100%;
  border: 1px solid black;
  border-spacing: 0;
  thead tr {
    background-color: #cccccc;
  }
  tbody tr:nth-child(odd) {
    background-color: #eeeeee;
  }
  tbody td {
    padding: 0.25em;
  }
  tr td:first-child,
  tr th:first-child {
    border-right: 1px solid black;
    width: 100px;
    text-align: center;
  }
`
const Li = styled.li`
  position: relative;
  list-style: none;
`
const FloatingCheckbox = styled(Checkbox)`
  position: absolute;
  left: -20px;
`

const shortName = {
  performanceCriteria: 'PC',
  performanceEvidence: 'PE',
  knowledgeEvidence: 'KE',
}

const UnitElement = ({
  unit,
  type,
  element,
  index,
  mapping,
  disabled,
  onChangeMapping,
  ...restProps
}) => {
  const { text, items = [] } = element || unit[type][index[0]]
  return (
    <div {...restProps}>
      <span>
        {type &&
          <b>
            {shortName[type]}
          </b>}{' '}
        {text}
      </span>
      {items.length > 0 &&
        <ul>
          {items.map(({ text, items = [] }, i) => {
            const subItemDisabled = disabled || (mapping && mapping.disabled)
            const subItemChecked =
              (Array.isArray(mapping) &&
                mapping[i] &&
                mapping[i].mapped === true) ||
              disabled
            return (
              <Li key={i}>
                <FloatingCheckbox
                  disabled={subItemDisabled}
                  checked={subItemChecked}
                  onChange={({ target }) =>
                    onChangeMapping({
                      type,
                      index: [index, i].map(Number),
                      mapped: target.checked,
                    })}
                />
                {text}
                {items.length > 0 &&
                  <ul>
                    {items.map((text, j) => {
                      const subSubItemDisabled =
                        subItemDisabled || subItemChecked
                      const subSubItemChecked =
                        (Array.isArray(mapping) &&
                          mapping[i] &&
                          Array.isArray(mapping[i]) &&
                          mapping[i][j] &&
                          mapping[i][j].mapped === true) ||
                        subItemChecked
                      return (
                        <Li key={j}>
                          <FloatingCheckbox
                            disabled={subSubItemDisabled}
                            checked={subSubItemChecked}
                            onChange={({ target }) =>
                              onChangeMapping({
                                type,
                                index: [index, i, j].map(Number),
                                mapped: target.checked,
                              })}
                          />
                          {text}
                        </Li>
                      )
                    })}
                  </ul>}
              </Li>
            )
          })}
        </ul>}
    </div>
  )
}

const getRows = ({ mapping, showAll, unit, mappingWhitelist }) => {
  const mappedElements = mapping.reduce(
    (mappedElements, element) => {
      set(mappedElements, `${element.type}.${element.index.join('.')}`, {
        mapped: true,
        disabled: element.disabled,
      })
      return mappedElements
    },
    {
      performanceCriteria: {},
      performanceEvidence: {},
      knowledgeEvidence: {},
    },
  )

  let displayMapping = [
    ...unit.performanceCriteria.map((_, index) => ({
      type: 'performanceCriteria',
      index: [index],
      mapping: mappedElements.performanceCriteria[index],
    })),
    ...unit.performanceEvidence.map((_, index) => ({
      type: 'performanceEvidence',
      index: [index],
      mapping: mappedElements.performanceEvidence[index],
    })),
    ...unit.knowledgeEvidence.map((_, index) => ({
      type: 'knowledgeEvidence',
      index: [index],
      mapping: mappedElements.knowledgeEvidence[index],
    })),
  ]

  if (showAll) {
    // include all elements
    return displayMapping
  }
  return displayMapping.filter(
    element =>
      Array.isArray(element.mapping) ||
      (element.mapping && element.mapping.mapped) ||
      (!!mappingWhitelist && hasElement(element, mappingWhitelist)),
  )
}

class MappingSelector extends Component {
  handleChangeMapping = ({ type, index, mapped }) => {
    // remove any of current element in mapping then add element if mapped
    const mapping = this.props.mapping
      .filter(
        element =>
          !(
            element.type === type &&
            isEqual(element.index.slice(0, index.length), index)
          ),
      )
      .concat(mapped ? { type, index } : [])
    this.props.onChangeMapping(mapping)
  }

  render() {
    const { state: { unit }, mapping, showAll, mappingWhitelist } = this.props
    const rows = getRows({ mapping, showAll, unit, mappingWhitelist })
    return (
      <Container>
        <Table>
          <thead>
            <tr>
              <th>Mapped</th>
              <th>Unit Element</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(({ type, index, mapping }, i) =>
              <tr key={i}>
                <td>
                  <Checkbox
                    disabled={mapping && mapping.disabled}
                    checked={
                      (mapping && mapping.mapped && !Array.isArray(mapping)) ||
                      false
                    }
                    onChange={({ target }) =>
                      this.handleChangeMapping({
                        type,
                        index: [index].map(Number),
                        mapped: target.checked,
                      })}
                  />
                </td>
                <td>
                  <UnitElement
                    unit={unit}
                    type={type}
                    index={index}
                    mapping={mapping}
                    disabled={
                      (mapping && mapping.disabled) ||
                      (mapping && mapping.mapped && !Array.isArray(mapping))
                    }
                    onChangeMapping={this.handleChangeMapping}
                  />
                </td>
              </tr>,
            )}
          </tbody>
        </Table>
      </Container>
    )
  }
}

export default injectState(MappingSelector)



// WEBPACK FOOTER //
// ./src/Units/components/MappingSelector.js